import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useUserContext } from '../context/UserContext';
import ModalCreateUser from '../components/ModalCreateUser';

const LoginPage = () => {
  const { login, isAuthenticated, checkUsers } = useUserContext();
  const [loginform, setLoginform] = useState('');
  const [password, setPassword] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [notUsers, setNotUsers] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    const firstCheck = async () => {
      try {
        const usersLength = await checkUsers();
        if (usersLength.data === 0) {
          setNotUsers(0);
          openModal();
        }
      } catch (error) {
        console.log(error);
      }
    };

    firstCheck();
  }, [checkUsers]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      await login({ login: loginform, password });
      setErrorMsg('');
    } catch (error) {
      setErrorMsg(error.message || 'Ошибка при входе');
    }
  };

  if (isAuthenticated) {
    return <Navigate to="/" />;
  }

  return (
    <div className="login-page">
      <div className="login-page__bg" />
      <section className="login-card">
        <header className="login-card__header">
          <h1 className="login-card__title">Вход в систему</h1>
          <p className="login-card__subtitle">Введите логин и пароль для продолжения</p>
        </header>

        <form className="login-form" onSubmit={handleSubmit}>
          <label className="login-form__label" htmlFor="loginform">Логин</label>
          <input
            className="login-form__input"
            type="text"
            id="loginform"
            autoComplete="username"
            required
            value={loginform}
            onChange={(event) => setLoginform(event.target.value)}
          />

          <label className="login-form__label" htmlFor="password">Пароль</label>
          <input
            className="login-form__input"
            type="password"
            id="password"
            autoComplete="current-password"
            required
            value={password}
            onChange={(event) => setPassword(event.target.value)}
          />

          {errorMsg && <p className="login-form__error">{errorMsg}</p>}

          <button className="login-form__submit" type="submit">Войти</button>
        </form>
      </section>

      {isModalOpen && <ModalCreateUser onClose={closeModal} first={notUsers} />}
      </div>
  );
};

export default LoginPage;

